import { renderNodes } from './react-i18n/renderNodes.js';
export var Translation = function Translation(param) {
    var i18nKey = param.i18nKey, t = param.t, children = param.children, options = param.options;
    return renderNodes(children, t.format(i18nKey, options));
};

//# sourceMappingURL=Translation.js.map